import { default as WJElement } from '../wje-element/element.js';
import Col from './col.element.js';

// export * from "./col.element.js";
export default Col;

WJElement.define('wje-col', Col);
